/**
 * Product gallery: arrows, thumbnails, dots, touch swipe.
 * Uses event delegation for touch so swipe works after Hot Reload / section re-render.
 */
(function () {
  const SWIPE_THRESHOLD = 50;

  function findEl(root, selector) {
    return root.querySelector(selector);
  }

  function findEls(root, selector) {
    return Array.from(root.querySelectorAll(selector));
  }

  function initGallery(container) {
    if (container._productGalleryInit) return;
    container._productGalleryInit = true;

    const track = findEl(container, '[data-gallery-track]');
    const slides = findEls(container, '[data-gallery-slide]');
    const prevBtn = findEl(container, '[data-gallery-prev]');
    const nextBtn = findEl(container, '[data-gallery-next]');
    const dots = findEls(container, '[data-gallery-dot]');
    const thumbs = findEls(container, '[data-gallery-thumb]');

    if (!track || slides.length === 0) return;

    var activeSlide = slides.find(function (s) { return s.classList.contains('is-active'); });
    var initialIndex = activeSlide ? parseInt(activeSlide.getAttribute('data-index'), 10) : 0;
    var currentIndex = !Number.isNaN(initialIndex) ? initialIndex : 0;
    const total = slides.length;

    function setActive(index) {
      const i = ((index % total) + total) % total;
      currentIndex = i;
      container._productGalleryCurrentIndex = currentIndex;

      slides.forEach(function (slide, idx) {
        const isActive = idx === i;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', !isActive);
      });

      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === i);
      });

      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === i);
      });

      var activeThumb = thumbs[i];
      if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function goPrev() {
      setActive(currentIndex - 1);
    }

    function goNext() {
      setActive(currentIndex + 1);
    }

    container._productGalleryGoPrev = goPrev;
    container._productGalleryGoNext = goNext;
    container._productGallerySetActive = setActive;
    container._productGalleryCurrentIndex = currentIndex;
    setActive(currentIndex);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goPrev(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goNext(); });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const idx = parseInt(dot.getAttribute('data-index'), 10);
        if (!Number.isNaN(idx)) setActive(idx);
      });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const idx = parseInt(thumb.getAttribute('data-index'), 10);
        if (!Number.isNaN(idx)) setActive(idx);
      });
    });
  }

  function run() {
    const galleries = document.querySelectorAll('[data-product-gallery]');
    galleries.forEach(initGallery);
  }

  /** Delegated touch swipe: only single-finger horizontal swipe changes slide; pinch/zoom is ignored */
  document.addEventListener('touchstart', function (e) {
    var track = e.target && e.target.closest && e.target.closest('[data-gallery-track]');
    if (!track || !e.touches.length) return;
    var container = track.closest('[data-product-gallery]');
    if (!container) return;
    if (e.touches.length >= 2) {
      container._touchMultiTouch = true;
      return;
    }
    container._touchStartX = e.touches[0].screenX;
    container._touchMultiTouch = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var track = e.target && e.target.closest && e.target.closest('[data-gallery-track]');
    if (!track || !e.touches.length) return;
    var container = track.closest('[data-product-gallery]');
    if (container && e.touches.length >= 2) container._touchMultiTouch = true;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var track = e.target && e.target.closest && e.target.closest('[data-gallery-track]');
    if (!track || !e.changedTouches.length) return;
    var container = track.closest('[data-product-gallery]');
    if (!container || container._touchStartX == null) return;
    if (container._touchMultiTouch) {
      container._touchStartX = null;
      container._touchMultiTouch = false;
      return;
    }
    var touchEndX = e.changedTouches[0].screenX;
    var diff = container._touchStartX - touchEndX;
    container._touchStartX = null;
    container._touchMultiTouch = false;
    if (Math.abs(diff) >= SWIPE_THRESHOLD && container._productGalleryGoNext && container._productGalleryGoPrev) {
      if (diff > 0) container._productGalleryGoNext();
      else container._productGalleryGoPrev();
    }
  }, { passive: true });

  document.addEventListener('touchcancel', function (e) {
    var track = e.target && e.target.closest && e.target.closest('[data-gallery-track]');
    if (!track) return;
    var container = track.closest('[data-product-gallery]');
    if (container) {
      container._touchStartX = null;
      container._touchMultiTouch = false;
    }
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /** Re-init when Shopify injects new sections (e.g. theme editor / Hot Reload) */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector && e.target.querySelector('[data-product-gallery]');
    if (section) initGallery(section);
  });
})();
